define('core/utils/uniqueId',[],function () {
    'use strict';

    var MAX_RANGE = 10000;
    var uid = Math.floor((Math.random() * MAX_RANGE) + 1);

    // NOTE: Ported from underscore 1.8.3
    return function uniqueId(prefix) {
        uid += 1;
        var id = String(uid);
        return prefix ? prefix + id : id;
    };
});

